<template>
    <toolbar-option type="stacked">
        <template slot="secondary">
            <dropdown
                :value="unit"
                :options="unitOptions"
                native
                @input="onUnitInput"
            />
        </template>

        <template slot="primary">
            <collapse id="control-gutter" v-model="slider">
                <slider
                    :value="sliderIndex"
                    :values="themeObjectValues"
                    @input="onInput"
                />
            </collapse>
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option-slider';
import { FlexClassGroup, FlexClassCollection } from '@/data/tailwind';
import { generateClass, getClassDefinition } from '@/utils/tailwind-helper';
import {
    CUSTOM_ATTR_NAME,
    FLEX_CLASS_GROUPS,
} from '@/data/constants/collection-item-classes';

export default {
    mixins: [baseOption],

    data() {
        return {
            // these should be overwritten
            displayName: 'Item Class',
            tailwindDefinitionProp: 'width',
            defaultUnit: 'auto',

            itemClassesNew: null,
        };
    },

    computed: {
        flexClass() {
            if (!this.itemClasses[this.tailwindDefinitionProp]) return '';

            let className = this.itemClasses[this.tailwindDefinitionProp][this.screen].default;

            // if no class exists for the current screen, check if one is set for all screens
            if (!className) {
                className = this.itemClasses[this.tailwindDefinitionProp].all.default;
            }

            return className;
        },

        itemClasses() {
            return this.selectedElements[0].getElementData(CUSTOM_ATTR_NAME) || new FlexClassCollection(null, FLEX_CLASS_GROUPS);
        },
    },

    watch: {
        itemClasses: {
            handler(val) {
                this.itemClassesNew = val;
            },
            deep: true,
            immediate: true,
        },
    },

    methods: {
        onInput(index) {
            const className = this.getClassByIndex(index);

            this.addClass(className);
        },

        async onUnitInput(unit) {
            this.unit = unit;
            this.removeFlexClass();
            await this.updateSlider();

            if (unit === '%') {
                const className = this.getClassByIndex(this.sliderIndex);
                this.addClass(className);
            }

            if (unit === 'vw') {
                const className = this.getClassByValue('100vw');
                this.addClass(className);
            }
        },

        onSelectedElement() {
            this.unit = this.getUnitFromClass(this.flexClass) || this.defaultUnit;
            this.updateSlider();
        },

        async updateSlider() {
            switch (this.unit) {
                case 'rem':
                    if (!this.flexClass) {
                        this.sliderIndex = 0;
                    } else {
                        this.sliderIndex = this.getIndexByClass(this.flexClass);
                    }

                    this.slider = true;
                    break;

                case '%':
                    this.slider = true;

                    if (this.flexClass) {
                        this.sliderIndex = this.getIndexByClass(this.flexClass);
                    } else {
                        await this.setSliderMax();
                    }

                    break;

                case 'vw':
                    this.slider = false;
                    break;

                default:
                    this.slider = false;
            }
        },

        getUnitFromClass(className) {
            const classDefinition = getClassDefinition(className);
            return classDefinition.unit;
        },

        getClassByIndex(index) {
            return generateClass({
                screen: this.screen,
                tailwindDefinitionProp: this.tailwindDefinitionProp,
                value: this.themeObjectValues[index],
            });
        },

        getClassByValue(val) {
            return generateClass({
                screen: this.screen,
                tailwindDefinitionProp: this.tailwindDefinitionProp,
                value: val,
            });
        },

        addClass(className) {
            if (!this.itemClassesNew[this.tailwindDefinitionProp]) {
                this.itemClassesNew[this.tailwindDefinitionProp] = new FlexClassGroup();
            }

            this.itemClassesNew[this.tailwindDefinitionProp][this.screen].default = className;
            this.save();
        },

        removeFlexClass() {
            if (!this.itemClassesNew[this.tailwindDefinitionProp]) return;

            this.itemClassesNew[this.tailwindDefinitionProp][this.screen].default = '';
            this.save();
        },

        save() {
            this.selectedElements[0].setElementData(CUSTOM_ATTR_NAME, this.itemClassesNew);
        },
    },
};
</script>
